<div class="projects-container">
  <div class="row ms-0 me-0">
    <div class="col-lg-2 col-md-4 col-sm-12 d-flex flex-column flex-sm-wrap flex-lg-nowrap p-0 project-container w-100">
      @if (canCreateProject) {
        <div class="new-project d-flex align-items-center">
          <button class="btn btn-new me-auto" (click)="createProject()">
            <i class="fa fa-plus me-2" aria-hidden="true"></i>
            <span>{{ 'workspace_edit_createNewProject' | translate }}</span>
          </button>

          <div ngbDropdown class="d-inline-block sort-dropdown ms-auto">
            <div class="toggle me-2" ngbDropdownToggle>
              <i
                class="fa"
                aria-hidden="true"
                [ngClass]="{
                  'fa-sort-alpha-asc':
                    projectSorting?.btn === ProjectSortCriteria.ProjectName && projectSorting?.sortDirection,
                  'fa-sort-alpha-desc':
                    projectSorting?.btn === ProjectSortCriteria.ProjectName && !projectSorting?.sortDirection,
                  'fa-sort-numeric-asc':
                    projectSorting?.btn === ProjectSortCriteria.StartDate && projectSorting?.sortDirection,
                  'fa-sort-numeric-desc':
                    projectSorting?.btn === ProjectSortCriteria.StartDate && !projectSorting?.sortDirection,
                  'fa-sort-amount-asc':
                    projectSorting?.btn === ProjectSortCriteria.DueDate && projectSorting?.sortDirection,
                  'fa-sort-amount-desc':
                    projectSorting?.btn === ProjectSortCriteria.DueDate && !projectSorting?.sortDirection,
                }"></i>
            </div>
            <div ngbDropdownMenu>
              <button ngbDropdownItem (click)="updateProjectSorting(ProjectSortCriteria.ProjectName, true)">
                <i class="fa fa-sort-alpha-asc me-2" aria-hidden="true"></i>
                <span>{{ 'dashboard_sortByProjectNameAsc' | translate }}</span>
              </button>
              <button ngbDropdownItem (click)="updateProjectSorting(ProjectSortCriteria.ProjectName, false)">
                <i class="fa fa-sort-alpha-desc me-2" aria-hidden="true"></i>
                <span>{{ 'dashboard_sortByProjectNameDesc' | translate }}</span>
              </button>
              <button ngbDropdownItem (click)="updateProjectSorting(ProjectSortCriteria.StartDate, true)">
                <i class="fa fa-sort-numeric-asc me-2" aria-hidden="true"></i>
                <span>{{ 'dashboard_sortByStartDateAsc' | translate }}</span>
              </button>
              <button ngbDropdownItem (click)="updateProjectSorting(ProjectSortCriteria.StartDate, false)">
                <i class="fa fa-sort-numeric-desc me-2" aria-hidden="true"></i>
                <span>{{ 'dashboard_sortByStartDateDesc' | translate }}</span>
              </button>
              <button ngbDropdownItem (click)="updateProjectSorting(ProjectSortCriteria.DueDate, true)">
                <i class="fa fa-sort-amount-asc me-2" aria-hidden="true"></i>
                <span>{{ 'dashboard_sortByDueDateAsc' | translate }}</span>
              </button>
              <button ngbDropdownItem (click)="updateProjectSorting(ProjectSortCriteria.DueDate, false)">
                <i class="fa fa-sort-amount-desc me-2" aria-hidden="true"></i>
                <span>{{ 'dashboard_sortByDueDateDesc' | translate }}</span>
              </button>
            </div>
          </div>
        </div>
      }

      <div class="flex-fill projects">
        @for (project of projects | ProjectSorting: [projectSorting]; track $index) {
          <button
            class="d-flex btn p-3 align-items-center justify-content-center project-item"
            [class.active]="project === selectedProject"
            (click)="selectProjectItem(project)">
            <div class="me-2">
              <mtm-item-icon
                [name]="project.name"
                [imageUrl]="project.avatarUrl"
                [width]="'30px'"
                [height]="'30px'"
                [generatedTextColor]="true">
              </mtm-item-icon>
            </div>
            <div class="flex-fill name">
              {{ project.name }}
            </div>
          </button>
        }
      </div>
    </div>

    <div
      class="col-lg-10 col-md-8 col-sm-12 d-flex flex-column flex-lg-nowrap flex-md-nowrap flex-sm-wrap user-container w-100">
      <div class="align-items-center buttons d-flex flex-lg-nowrap flex-md-nowrap flex-sm-wrap flex-wrap my-3 w-100">
        @if (selectedProject) {
          <button
            type="button"
            class="btn add-user"
            (click)="showAddModal()"
            [disabled]="!canEditProject"
            [attr.data-title]="'workspace_edit_cantAddUser' | translate"
            [class.tool-tipped]="!canEditProject">
            <i class="fa fa-plus-circle" aria-hidden="true"></i>
            {{ 'workspace_edit_addNewUser' | translate }}
          </button>

          <button type="button" class="btn ms-sm-0 ms-lg-3 go-project" (click)="goToProject()">
            <i class="fa fa-arrow-right" aria-hidden="true"></i>
            {{ 'workspace_edit_goToProject' | translate }} "{{ selectedProject.name }}"
          </button>
        }
      </div>

      <div>
        @if (!!(localFilterParams?.fullName || localFilterParams?.email)) {
          <div class="d-flex justify-content-end">
            <span class="p-2"
              >Total:
              {{ (participants | FilterUser: localFilterParams?.fullName : localFilterParams?.email).length }}
              records</span
            >
          </div>
        }
        <ag-grid-angular
          #workspaceProjectParticipantsTable
          mtmAgAlpineTheme
          [rowData]="
            participants
              | FilterUser: localFilterParams?.fullName : localFilterParams?.email : localFilterParams?.decisionMaker
          "
          [rowHeight]="120"
          [defaultColDef]="defaultColDef"
          class="ag-theme-alpine"
          [columnDefs]="workspaceProjectParticipantColumnsDef"
          [headerHeight]="72"
          [domLayout]="'autoHeight'"
          [context]="tableContext"
          [components]="components"
          [gridOptions]="gridOptions">
        </ag-grid-angular>
      </div>
    </div>
  </div>
</div>
